import React, { useState } from "react";
import { Stack } from "@mui/material";

import { SideNavBarV2 } from "../../components";
import { sidetabs } from "./helper";

const STORAGE_KEY = "Schedule-View";

const getInitialTab = () => {
  const stored = localStorage?.getItem(STORAGE_KEY);
  const storedId = stored != null ? Number(stored) : null;
  if (storedId && sidetabs.some((t) => t.id === storedId)) return storedId;
  return sidetabs[0].id;
};

const SchedulePageContent = () => {
  const [tab, setTab] = useState(getInitialTab);
  const Component = sidetabs?.find((t) => t.id === tab)?.Component;

  const handleSetTab = (id) => {
    localStorage?.setItem(STORAGE_KEY, String(id));
    setTab(id);
  };

  return (
    <Stack direction="row" width="100%" height="100%" overflow="hidden">
      <SideNavBarV2 tabs={sidetabs} value={tab} setValue={handleSetTab} />
      <Component />
    </Stack>
  );
};

export default SchedulePageContent;
